// extracted by mini-css-extract-plugin
export default {"navLink":"profile-nav-link_navLink__oEtXU","navLinkActive":"profile-nav-link_navLinkActive__QuwyK"};